import React from "react";

import { node, bool } from "prop-types";

import { Header as AppHeader } from "../index";

const formClosedDescription =
  "To help us find the best roles for you, please tell us about your work experience and background.";

export const Content = ({ children }) => (
  <div className="col-md-10 offset-md-1 mb-3">{children}</div>
);

Content.propTypes = {
  children: node.isRequired,
};

export const Header = ({ showForm }) => (
  <AppHeader description={showForm ? "" : formClosedDescription}>
    {showForm ? "" : <h2 className="mb-hf">Tell us about your work history</h2>}
  </AppHeader>
);

Header.propTypes = {
  showForm: bool.isRequired,
};
